import type { SVGProps } from 'react';
const SvgPaddleboard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path
      fillRule="evenodd"
      d="M19.26 3.324c.141.028.284.05.425.083a3.1 3.1 0 0 1 1.744 1.087c.34.418.561.889.65 1.415.15.898-.054 1.72-.613 2.444-.468.605-1.09.979-1.837 1.148-.31.07-.627.089-.942.06a3.4 3.4 0 0 1-.953-.245 3 3 0 0 1-.712-.421 3.2 3.2 0 0 1-.785-.92 3 3 0 0 1-.374-1.063 3.1 3.1 0 0 1 .182-1.596q.212-.538.598-.966a3.17 3.17 0 0 1 2.026-1.01c.004 0 .007-.01.01-.016h.395a.2.2 0 0 0 .145 0z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M18.48 3.324h1.331v.673h-1.33v-.673Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M19.218 3.324c-.047.038-.097.028-.145 0zm-2.222 7.495h-.768c.153-.036.309-.012.462-.015.1-.001.205-.02.306.015m.14 24.186h1.332v.67h-1.332z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M17.578 35.657c.15 0 .299-.006.448.014-.15-.007-.3.019-.448-.014m3.41-.652h1.331v.67h-1.33z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M21.431 35.67c.148-.019.297-.013.445-.013-.148.033-.297.008-.445.013m-5.364-.686h1.33v.69h-1.33z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M16.602 35.636c.087 0 .175-.008.26.014-.087-.005-.174.018-.26-.014m5.456-.652h1.331v.69h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M22.594 35.65c.086-.02.172-.014.259-.014-.086.032-.172.01-.259.013ZM3.328 32.488h.675v1.32h-.675z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.347 33.035v.226a.35.35 0 0 1 0-.226M29.94 8.33v-.205a.3.3 0 0 1 0 .205M14.695 34.943h1.33v.731h-1.33z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15.252 35.595c.072 0 .146-.006.216.013-.072-.004-.145.018-.216-.013m7.574-.632h1.331v.711h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M23.384 35.629c.07-.019.143-.015.215-.013-.069.031-.144.009-.215.013"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M23.438 34.942h1.331v.732h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M24.004 35.609c.065-.02.132-.015.198-.015-.063.032-.131.01-.198.015m-8.695-.646h1.331v.711h-1.33v-.711Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15.876 35.615c.066 0 .133-.006.198.015-.067-.006-.135.016-.199-.015Zm-1.71-.693h1.332v.752h-1.332z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M14.754 35.574c.052 0 .105-.006.156.015-.052-.006-.107.016-.156-.015m9.202-.653h1.332v.753h-1.332z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M24.544 35.588c.05-.021.104-.013.156-.014-.05.03-.104.009-.156.014m1.086-.748h1.331v.834H25.63z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M26.229 35.505c.042-.017.088-.013.133-.013-.041.029-.09.01-.133.013m-12.966-.625h1.332v.794h-1.332z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.861 35.533c.045 0 .092-.005.136.014-.045-.003-.093.015-.136-.014m11-.653h1.332v.794H24.86v-.794Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M25.46 35.546c.043-.017.088-.014.133-.013-.042.03-.089.01-.133.013m-11.781-.645h1.33v.773h-1.33z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M14.276 35.553c.046 0 .092-.005.136.015-.045-.004-.093.014-.136-.015m10.169-.652h1.331v.773h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M25.043 35.568c.044-.02.09-.014.135-.015-.042.03-.09.01-.136.015Zm1.574-.791h1.331v.897h-1.33v-.897Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M27.228 35.443a.23.23 0 0 1 .11-.013c-.034.027-.073.012-.11.013"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M26.304 34.798h1.332v.876h-1.332z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M26.914 35.464a.25.25 0 0 1 .112-.013c-.035.026-.075.011-.112.013m-14.764-.646h1.332v.856H12.15z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.76 35.471c.039-.001.076-.004.112.013-.037 0-.077.014-.112-.013"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.504 34.84h1.331v.834h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.113 35.492c.038 0 .076-.004.112.013-.037-.001-.077.014-.112-.013"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.858 34.86h1.331v.814h-1.33z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.466 35.512c.04 0 .079-.005.115.015-.039-.004-.079.013-.114-.015Zm11.8-.652h1.331v.814h-1.331z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M25.876 35.526c.036-.018.074-.015.112-.014-.035.027-.075.012-.112.014"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M25.005 23.478q-.184 1.036-.366 2.073l-.402 2.276-.324 1.832a.4.4 0 0 1-.045.135c-.446.72-.872 1.451-1.327 2.164-.043.067-.087.09-.166.09-1.02-.004-2.042-.002-3.079-.002.078-.156.148-.299.179-.459a1 1 0 0 0 .013-.174l.001-6.128c0-.037-.006-.078.006-.113.094-.266.032-.521-.039-.784-.065-.243-.234-.407-.383-.587q-1.237-1.489-2.48-2.971c-.038-.045-.047-.083-.028-.137q1.003-3.02 2.007-6.04l.017-.05.477.404c.735.623 1.47 1.25 2.207 1.871.2.17.45.248.683.36a982 982 0 0 0 3.756 1.774c.062.03.071.06.06.126q-.206 1.147-.407 2.297zm10.97 9.451c-.068-.386-.289-.652-.668-.775a2.5 2.5 0 0 0-.78-.108h-8.483c-.061 0-.105-.002-.131-.076q-.366-.989-.735-1.978a.2.2 0 0 1-.016-.1q.158-.9.315-1.8.205-1.165.406-2.328.21-1.22.418-2.44.113-.64.228-1.28l.158-.89q.099-.567.195-1.134c.022-.133.043-.268.071-.4.003-.017-.008-.075.048-.054.06.024.123.012.183.01a1.24 1.24 0 0 0 .864-.342c.3-.288.438-.639.391-1.055a1.22 1.22 0 0 0-.404-.786c-.164-.153-.367-.23-.561-.326-.06-.03-.08-.06-.065-.135.058-.292.106-.586.157-.88l.194-1.133q.102-.564.2-1.129c.073-.417.141-.834.213-1.252l.245-1.39.269-1.531c.005-.03.01-.052.038-.064.088-.035.172-.082.263-.108.543-.157.894-.567.951-1.115a1 1 0 0 0 0-.204c-.052-.387-.22-.704-.55-.928-.473-.318-.967-.257-1.45-.045-.481.212-.944.46-1.417.69-1.093.532-2.178 1.083-3.273 1.611-.152.073-.29.186-.45.235-.724.22-1.453.423-2.18.633l-.898.26c.07.065.124.123.186.17.177.136.336.292.505.439.076.067.149.139.228.202.166.133.322.279.483.417.138.12.271.246.41.365.168.145.338.29.502.441.06.053.106.07.18.038q.31-.135.626-.264c.37-.153.747-.282 1.105-.457 1.07-.523 2.132-1.062 3.196-1.594.04-.02.075-.049.131-.051l-.117.68q-.084.518-.172 1.034-.09.51-.18 1.02c-.06.344-.113.689-.171 1.034-.067.383-.14.764-.203 1.147-.065.402-.137.802-.206 1.204-.013.074-.03.062-.077.04l-1.221-.587c-.383-.184-.772-.354-1.147-.55-.457-.237-.952-.4-1.34-.766-.36-.34-.757-.643-1.138-.962l-1.029-.87c-.431-.361-.86-.725-1.292-1.082-.182-.151-.347-.325-.564-.427-.45-.213-.914-.374-1.42-.384a13 13 0 0 0-.768 0c-.278.009-.558.017-.834.068-.332.062-.617.2-.8.502a3 3 0 0 0-.272.608q-.466 1.358-.934 2.716-.477 1.393-.957 2.785-.265.779-.538 1.555c-.11.315-.137.64-.1.965.033.311.132.615.288.892q.169.301.41.554c.117.124.265.207.385.325.217.211.41.442.615.665l.662.72c.203.223.41.444.612.668q.309.345.627.682c.185.195.36.4.548.592.139.138.264.291.401.433a.4.4 0 0 1 .124.304q-.005 2.745-.002 5.49-.001.12.01.242c.017.16.082.303.137.46h-4.86c-.07 0-.138-.002-.208.002-.058.003-.078-.003-.053-.071.095-.268.181-.54.27-.809l.638-1.928c.46-1.388.918-2.775 1.382-4.16.032-.093.049-.163-.038-.232-.05-.04-.086-.096-.129-.146l-.973-1.128-.576-.67-.633-.723-.013.01q-1.47 4.383-2.942 8.763c-.078.233-.146.464-.134.715.005.127.052.247.042.378-.573 0-1.149-.004-1.722 0-.723.008-1.446-.027-2.169.02-.232.017-.46.063-.662.179a.94.94 0 0 0-.484.79q-.012.112 0 .226c.024.227.09.44.213.635.13.205.29.382.515.471.237.094.498.115.748.164.278.056.558.103.838.152.271.048.543.097.814.138.31.044.618.096.93.133.392.046.782.11 1.174.158.352.043.708.072 1.06.106.357.034.714.07 1.07.1.331.03.661.05.991.084q.24.022.477.037c.194.011.389.027.583.033.037.01.077-.004.113.013q.12.004.241.006c.036.012.076-.002.112.014l.24.008c.038.01.078-.003.115.013l.28.006c.044.014.092-.004.136.015l.28.007c.043.011.091-.004.135.014l.342.007c.05.013.105-.007.156.013l.342.006c.072.016.145-.008.217.014l.406.008c.065.014.133-.008.198.013l.529.006c.086.016.174-.008.26.015l.717.007c.148.017.298-.011.446.014q.041-.006.083-.008 1.134.005 2.268.008.527.001 1.056-.001c.147-.023.297.002.444-.014l.72-.006c.083-.023.17.001.256-.015q.265-.001.531-.006c.072-.021.145.001.217-.013q.203-.005.403-.007c.066-.021.134 0 .199-.015l.342-.006c.05-.02.105 0 .157-.013q.17-.005.342-.007c.043-.018.09-.003.135-.014q.142-.005.282-.007c.044-.019.09-.001.133-.013l.282-.008c.038-.017.076-.003.113-.013l.241-.008c.043-.018.09 0 .133-.014.184-.005.368-.035.552-.027.035-.016.075-.002.113-.014l.2-.006c.037-.019.075-.001.111-.015q.19-.013.378-.027.588-.05 1.172-.1c.28-.023.559-.04.837-.068.418-.042.835-.093 1.252-.14q.357-.04.714-.089.544-.076 1.088-.158c.323-.048.65-.094.973-.15.429-.076.855-.174 1.286-.237.398-.06.66-.273.821-.623a1.5 1.5 0 0 0 .116-.908Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaddleboard;
